import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/home.vue";
import i18n from "../lang/i18n";
Vue.use(VueRouter);
const routes = [
  {
    path: "/",
    name: "/",

    component: () => import("../views/big-screen/index.vue"),  


    meta: {
      title: i18n.t('rbac.screen'),
    },
  },

  {
    path: "/single",
    name: "/single",

    // component: () => import("../views/big-screen/index.vue"),  

    component: () => import("../views/big-screen-single/index.vue"), //单点料位

    meta: {
      title: i18n.t('rbac.screen'),
    },
  },

  // 单仓可视化大屏详情页
  {
    path: "/big-screen-detail",
    name: "big-screen-detail",
    hidden: true,
    component: () => import("../views/big-screen/detail.vue"),
    meta: {
      title: i18n.t('rbac.screen'),
    },
  },


  //mini-小程序页面
  {
    path: "/mini",
    name: " mini",

    hidden: true,
    // 如果需要添加子菜单,请将文件改为index,然后添加即可
    component: () => import("../views/mini/points.vue"),
    meta: {
      title: "小程序",
    },
  },

  



  {
    path: "/home",

    hidden: false,
    component: HomeView,
    meta: {
      title: i18n.t('rbac.homePage'),
    },
    children: [
      {
        path: "/",
        name: "",

        hidden: false,
        //component: () => import("../views/index.vue"),
        meta: {
          icon: "bar-chart",
          title: i18n.t('rbac.screen'),
        },
      },

      {
        path: "/quantity-detection",
        name: " quantity-detection",
        hidden: false,
        // 如果需要添加子菜单,请将文件改为index,然后添加即可
        component: () => import("../views/quantity-detection/index.vue"),
        meta: {
          icon: "fund",
          title: i18n.t('rbac.detection'),
        },
        children: [
          {
            path: "/test-control",
            name: "test-control",
            hidden: false,
            component: () =>
              import("../views/quantity-detection/test-control.vue"),
            meta: {
              title: i18n.t('rbac.detection'),
            },
          },
          {
            path: "/test-record",
            name: "test-record",
            hidden: false,
            component: () =>
              import("../views/quantity-detection/test-record.vue"),
            meta: {
              title: i18n.t('rbac.historicalData'),
            },
          },
          {
            path: "/alarm-record",
            name: "alarm-record",
            hidden: false,
            component: () =>
              import("../views/quantity-detection/alarm-record.vue"),
            meta: {
              title: i18n.t('rbac.alarmRecord'),
            },
          },
          //库存统计
          {
            path: "/test-stock",
            name: "test-stock",
            hidden: false,
            component: () =>
              import("../views/quantity-detection/test-stock.vue"),
            meta: {
              title: i18n.t('detection.stockStatistics'),
            },
          },

          //变动统计
          {
            path: "/test-change",
            name: "test-change",
            hidden: false,
            component: () =>
              import("../views/quantity-detection/test-change.vue"),
            meta: {
              title: i18n.t('detection.changeStatistics'),
            },
          },

          {
            path: "/test-bench",
            name: " test-bench",
            hidden: true,
            // 如果需要添加子菜单,请将文件改为index,然后添加即可
            component: () =>
              import("../views/quantity-detection/test-bench.vue"),
            meta: {
              title: i18n.t('rbac.singleBarnDisplay'),
            },
          },
          {
            path: "/history",
            name: " history",

            hidden: true,
            // 如果需要添加子菜单,请将文件改为index,然后添加即可
            component: () => import("../views/quantity-detection/history.vue"),
            meta: {
              title: i18n.t('rbac.historicalData'),
            },
          },
        ],
      },


       //单点料位

       {
        path: "/quantity-detection-single",
        name: " quantity-detection-single",
        hidden: false,
        // 如果需要添加子菜单,请将文件改为index,然后添加即可
        component: () => import("../views/quantity-detection-single/index.vue"),
        meta: {
          icon: "fund",
          title: i18n.t('rbac.detection'),
        },
        children: [
          {
            path: "/test-control-single",
            name: "test-control-single",
            hidden: false,
            component: () =>
              import("../views/quantity-detection-single/test-control.vue"),
            meta: {
              title: i18n.t('rbac.detection'),
            },
          },
          {
            path: "/test-record-single",
            name: "test-record-single",
            hidden: false,
            component: () =>
              import("../views/quantity-detection-single/test-record.vue"),
            meta: {
              title: i18n.t('rbac.historicalData'),
            },
          },
          {
            path: "/alarm-record-single",
            name: "alarm-record-single",
            hidden: false,
            component: () =>
              import("../views/quantity-detection-single/alarm-record.vue"),
            meta: {
              title: i18n.t('rbac.alarmRecord'),
            },
          },
          {
            path: "/test-bench-single",
            name: " test-bench-single",
            hidden: true,
            // 如果需要添加子菜单,请将文件改为index,然后添加即可
            component: () =>
              import("../views/quantity-detection-single/test-bench.vue"),
            meta: {
              title: i18n.t('rbac.singleBarnDisplay'),
            },
          },
          {
            path: "/history-single",
            name: " history-single",

            hidden: true,
            // 如果需要添加子菜单,请将文件改为index,然后添加即可
            component: () => import("../views/quantity-detection-single/history.vue"),
            meta: {
              title: i18n.t('rbac.historicalData'),
            },
          },
        ],
      },



      //线缆温湿度仓

      {
        path: "/quantity-detection-cable",
        name: " quantity-detection-cable",
        hidden: false,
        // 如果需要添加子菜单,请将文件改为index,然后添加即可
        component: () => import("../views/quantity-detection-cable/index.vue"),
        meta: {
          icon: "fund",
          title: i18n.t('rbac.detection'),
        },
        children: [
          {
            path: "/test-control-cable",
            name: "test-control-cable",
            hidden: false,
            component: () =>
              import("../views/quantity-detection-cable/test-control.vue"),
            meta: {
              title: i18n.t('rbac.detection'),
            },
          },
          {
            path: "/test-record-cable",
            name: "test-record-cable",
            hidden: false,
            component: () =>
              import("../views/quantity-detection-cable/test-record.vue"),
            meta: {
              title: i18n.t('rbac.historicalData'),
            },
          },
          {
            path: "/alarm-record-cable",
            name: "alarm-record-cable",
            hidden: false,
            component: () =>
              import("../views/quantity-detection-cable/alarm-record.vue"),
            meta: {
              title: i18n.t('rbac.alarmRecord'),
            },
          },
          {
            path: "/test-bench-cable",
            name: " test-bench-cable",
            hidden: true,
            // 如果需要添加子菜单,请将文件改为index,然后添加即可
            component: () =>
              import("../views/quantity-detection-cable/test-bench.vue"),
            meta: {
              title: i18n.t('rbac.singleBarnDisplay'),
            },
          },
          {
            path: "/history-cable",
            name: " history-cable",

            hidden: true,
            // 如果需要添加子菜单,请将文件改为index,然后添加即可
            component: () => import("../views/quantity-detection-cable/history.vue"),
            meta: {
              title: i18n.t('rbac.historicalData'),
            },
          },
        ],
      },




       //温湿度仓

       {
        path: "/quantity-detection-humidity",
        name: " quantity-detection-humidity",
        hidden: false,
        // 如果需要添加子菜单,请将文件改为index,然后添加即可
        component: () => import("../views/quantity-detection-humidity/index.vue"),
        meta: {
          icon: "fund",
          title: i18n.t('rbac.detection'),
        },
        children: [
          {
            path: "/test-control-humidity",
            name: "test-control-humidity",
            hidden: false,
            component: () =>
              import("../views/quantity-detection-humidity/test-control.vue"),
            meta: {
              title: i18n.t('rbac.detection'),
            },
          },
          {
            path: "/test-record-humidity",
            name: "test-record-humidity",
            hidden: false,
            component: () =>
              import("../views/quantity-detection-humidity/test-record.vue"),
            meta: {
              title: i18n.t('rbac.historicalData'),
            },
          },
         
        ],
      },


      //多仓

      {
        path: "/quantity-detection-multi",
        name: " quantity-detection-multi",
        hidden: false,
        // 如果需要添加子菜单,请将文件改为index,然后添加即可
        component: () => import("../views/quantity-detection-multi/index.vue"),
        meta: {
          icon: "fund",
          title: i18n.t('rbac.detection'),
        },
        children: [
          {
            path: "/test-control-multi",
            name: "test-control-multi",
            hidden: false,
            component: () =>
              import("../views/quantity-detection-multi/test-control.vue"),
            meta: {
              title: i18n.t('rbac.detection'),
            },
          },
          {
            path: "/test-record-multi",
            name: "test-record-multi",
            hidden: false,
            component: () =>
              import("../views/quantity-detection-multi/test-record.vue"),
            meta: {
              title: i18n.t('rbac.historicalData'),
            },
          },

          {
            path: "/history-multi",
            name: " history-multi",

            hidden: true,
            // 如果需要添加子菜单,请将文件改为index,然后添加即可
            component: () => import("../views/quantity-detection-multi/history.vue"),
            meta: {
              title: i18n.t('rbac.historicalData'),
            },
          },
          {
            path: "/test-bench-multi",
            name: "test-bench-multi",
            hidden: true,
            component: () =>
              import("../views/quantity-detection-multi/test-bench.vue"),
            meta: {
              title: "单仓显示",
            },
          },
         
        ],
      },



      {
        path: "/system-management",
        name: "system-management",

        hidden: false,
        component: () =>
          import("../views/system-management/warehouse-information.vue"),
        // 如果需要添加子菜单,请将文件改为index,然后添加即可
        meta: {
          icon: "profile",
          title: i18n.t('rbac.barnList'),
        },

        // children: [
        //   {
        //     path: "/warehouse-information",
        //     name: "warehouse-information",
        //
        //     component: () =>
        //       import("../views/system-management/warehouse-information.vue"),
        //     meta: {
        //       icon: "info-circle",
        //       title: "仓房信息",
        //     },
        //   },
        // ],
      },

      {
        path: "/system-management-single",
        name: "system-management-single",

        hidden: false,
        component: () =>
          import("../views/system-management-single/warehouse-information.vue"),
        // 如果需要添加子菜单,请将文件改为index,然后添加即可
        meta: {
          icon: "profile",
          title: i18n.t('rbac.barnList'),
        },

        // children: [
        //   {
        //     path: "/warehouse-information",
        //     name: "warehouse-information",
        //
        //     component: () =>
        //       import("../views/system-management/warehouse-information.vue"),
        //     meta: {
        //       icon: "info-circle",
        //       title: "仓房信息",
        //     },
        //   },
        // ],
      },


      {
        path: "/system-management-cable",
        name: "system-management-cable",

        hidden: false,
        component: () =>
          import("../views/system-management-cable/warehouse-information.vue"),
        // 如果需要添加子菜单,请将文件改为index,然后添加即可
        meta: {
          icon: "profile",
          title: i18n.t('rbac.barnList'),
        },

        // children: [
        //   {
        //     path: "/warehouse-information",
        //     name: "warehouse-information",
        //
        //     component: () =>
        //       import("../views/system-management/warehouse-information.vue"),
        //     meta: {
        //       icon: "info-circle",
        //       title: "仓房信息",
        //     },
        //   },
        // ],
      },


      {
        path: "/system-management-humidity",
        name: "system-management-humidity",

        hidden: false,
        component: () =>
          import("../views/system-management-humidity/warehouse-information.vue"),
        // 如果需要添加子菜单,请将文件改为index,然后添加即可
        meta: {
          icon: "profile",
          title: i18n.t('rbac.barnList'),
        },
      },


      //多仓


      {
        path: "/system-management-multi",
        name: "system-management-multi",

        hidden: false,
        component: () =>
          import("../views/system-management-multi/warehouse-information.vue"),
        // 如果需要添加子菜单,请将文件改为index,然后添加即可
        meta: {
          icon: "profile",
          title: i18n.t('rbac.barnList'),
        },
      },



      {
        path: "/camera-management",
        name: "camera-management",

        hidden: false,
        component: () => import("../views/camera/index.vue"),
        // 如果需要添加子菜单,请将文件改为index,然后添加即可
        meta: {
          icon: "camera",
          title: i18n.t('rbac.cameraManage'),
        },
      },
      {
        path: "/historical-video",
        name: "historical-video",
        hidden: true,
        component: () =>
          import("../views/historical-video/historical-video.vue"),
        // 如果需要添加子菜单,请将文件改为index,然后添加即可
        meta: {
          icon: "play-circle",
          title: i18n.t('rbac.playback'),
        },
      },
      {
        path: "/history-playback",
        name: "history-playback",
        hidden: true,
        component: () =>
          import("../views/historical-video/history-playback.vue"),
        // 如果需要添加子菜单,请将文件改为index,然后添加即可
        meta: {
          icon: "play-circle",
          title: i18n.t('rbac.playback'),
        },
      },
      {
        path: "/camera",
        name: "camera",

        hidden: true,
        component: () => import("../views/camera/camera.vue"),
        // 如果需要添加子菜单,请将文件改为index,然后添加即可
        meta: {
          icon: "",
          title: i18n.t('rbac.cameraView'),
        },
      },

      {
        path: "/local-camera",
        name: "local-camera",

        hidden: true,
        component: () => import("../views/camera/local-camera.vue"),
        // 如果需要添加子菜单,请将文件改为index,然后添加即可
        meta: {
          icon: "",
          title: i18n.t('rbac.cameraView'),
        },
      },
      
      {
        path: "/parameter-configuration",
        name: "parameter-configuration",

        hidden: true,
        component: () =>
          import("../views/system-management/parameter-configuration.vue"),
        // 如果需要添加子菜单,请将文件改为index,然后添加即可
        meta: {
          icon: "profile",
          title: i18n.t('rbac.radarConfig'),
        },
      },
      {
        path: "/userlist",
        name: "userlist",

        hidden: false,
        component: () => import("../views/user/index.vue"),
        meta: {
          icon: "user",
          title: i18n.t('rbac.userManage'),
        },
      },

    

    
      {
        path: "/timing-task",
        name: "timing-task",
        hidden: false,
        component: () => import("../views/timing-task/index.vue"),
        meta: {
          icon: "dashboard",
          title: i18n.t('rbac.schedule'),
        },
      },
      {
        path: "/system",
        name: "system",

        hidden: true,
        component: () => import("../views/system/index.vue"),
        meta: {
          icon: "setting",
          title: i18n.t('rbac.systemManage'),
        },
      },


      {
        path: "/rbac",
        name: " rbac",
        hidden: false,
        // 如果需要添加子菜单,请将文件改为index,然后添加即可
        component: () => import("../views/rbac/index.vue"),
        meta: {
          icon: "setting",
          title: i18n.t('rbac.permissionManage'),
        },
        children: [
          {
            path: "/rolelist",
            name: "rolelist",
            hidden: false,
            component: () =>
              import("../views/rbac/Role.vue"),
            meta: {
              title: i18n.t('rbac.roleManage'),
            },
          },
          {
            path: "/menulist",
            name: "menulist",
            hidden: false,
            component: () =>
              import("../views/rbac/Permission.vue"),
            meta: {
              title: i18n.t('rbac.menuManage'),
            },
          },
         
        ],
      },


    ],
  },
  {
    path: "/login",
    name: "login",

    component: () => import("../views/login.vue"),
    meta: {
      title: i18n.t('rbac.login'),
    },
  },
  {
    path: "/house",
    name: "house",

    component: () => import("../views/house.vue"),
    meta: {
      title: i18n.t('rbac.barnDisplay'),
    },
  },
  {
    path: '/test-error-data',
    name: 'TestErrorData',
    component: () => import('@/views/test-error-data.vue')
  },
  {
    path: '/test-round-error-data',
    name: 'TestRoundErrorData',
    component: () => import('@/views/test-round-error-data.vue')
  }
];


console.log()

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
